import React, { Component } from "react";
import { Table, Popover, Input, Button, Icon, Spin, Pagination, Select, Modal, Row, Col, Form, Tooltip } from "antd";
import * as actions from "../../actions/index";
import ReactToPrint from "react-to-print";
import { compose } from "recompose";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SearchAlumniFilter from "../Inc/SearchAlumniFilter";
import SimplSearch from "../Inc/SimpleSearch";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { parseInt } from "lodash";

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const Option = Select.Option;
const FormItem = Form.Item;

let uuid = 0;
let selectedvalueArray = []

const getItems = count =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k}`,
    content: `item ${k}`,
  }));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: '0',
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: '',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = () => ({
  background: '',
});


class SearchAlumniClass extends Component {
  panelView = null
  constructor(props) {
    super(props)
    this.state = {
      ...props,
      currentpage: 1,
      pagecount: 0,
      perPageSize: 10,
      changecolumnvisible: false,
      items: getItems(10),
      columns: ['firstname', 'lastname', 'home_city', 'home_state', 'eaglecouncilnameandnumber', 'eaglescoutunitnumber', 'eaglescoutunitcity', 'eaglescoutunitstate', 'councilaffiliation', 'membershiptype', 'membershipstatus'],
      columnjson: [],
      panelView: null
    }
    this.onDragEnd = this.onDragEnd.bind(this);
    this.getcolumnlist = this.getcolumnlist.bind(this);
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    let source = result.source.index
    let destination = result.destination.index
    let columnValues = this.state.columns;
    columnValues[source] = columnValues.splice(destination, 1, columnValues[source])[0];

    this.setState({
      columns: columnValues
    });
  }

  remove = (k) => {
    const { form } = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue("keys");
    if (keys.length === 1) {
      return;
    }

    // can use data-binding to set
    form.setFieldsValue({
      keys: keys.filter(key => key !== k),
    });
  }

  add = (selectedvalue) => {
    const { form } = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue("keys");
    const nextKeys = keys.concat(uuid);

    selectedvalueArray.push(selectedvalue)
    //const selectedvalue = selectvalue
    uuid++;
    // can use data-binding to set
    // important! notify form to detect changes
    this.setState({
      selectedcolumnvalue: selectedvalueArray
    })
    form.setFieldsValue({
      keys: nextKeys,
      selectedvalueArray: selectedvalueArray
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          columns: values.columns,
          changecolumnvisible: false
        })
        let columnArr = values.columns;
        let columnjsonArr = [];
        columnArr.map(function (columnname) {
          columnjsonArr.push({
            title: columnname,
            dataIndex: columnname,
            key: columnname,
            sortDirections: ['descend', 'ascend']
          })
        })
        columnjsonArr.push({
          dataIndex: "edit",
          key: "edit",
          render: (text, record) => (
            <span className="editRow">
              <a href="/maintain-alumni" > <i className="fa fa-pencil margin-right-5"></i> Edit</a>
            </span>
          )
        })
        this.setState({
          columnjson: columnjsonArr,
        });
        // this.props.actions.QuickSearch(parseInt(this.state.currentpage), parseInt(this.state.currentpage), values.columns, "quickserach", parseInt(this.state.perPageSize))

        let maxRecord = 0;
        let expressions = this.state.preference.Expressions;
        if(expressions) {
          let columnName = "membershipstatus";
          let value = 'active';

          expressions.forEach(function(obj) {
            if (obj.Value === "National Eagle Scout Association") {
              obj.ColumnName = columnName;
              obj.Value = value;
              maxRecord = 10000;
            }
          })
        } 

        this.props.actions.savelist(this.state.preference, 'quicksearch', '4', this.state.columns, false, parseInt(this.state.perPageSize), parseInt(this.state.currentpage), maxRecord )
      }
    });
  }

  componentDidMount = () => {

    let getPanelView = localStorage.getItem("panelView") ?  JSON.parse(localStorage.getItem("panelView")) : "alumniTabView"
    
      this.panelView = getPanelView
    
    this.props.actions.isadmin()
    this.getcolumnlist(this.state.columns)
  }

  handleSearchRedirect = (record, page) => {
    const isQuickAdminSearch = window.location.pathname.includes('/quick-search');
    const isAlumniSearch = window.location.pathname.includes('/alumni-search');
    const isAdvancedSearch = window.location.pathname.includes('/advanced-search');

    if (isQuickAdminSearch === true) {
      this.props.history.push(page + record.personguid + this.props.location.pathname)
    } else if (isAlumniSearch === true) {
      this.props.history.push(page + record.personguid + this.props.location.pathname)
    } else if (isAdvancedSearch === true) {
      this.props.history.push(page + record.personguid + this.props.location.pathname)
    }

  }

  componentWillUnmount = () => {
    if (this.props.preferencelist) {
      const isMaintainPath = window.location.pathname.includes('/maintain-alumni');
      const isAlumniViewPath = window.location.pathname.includes('/alumni-profile');
      if (isMaintainPath === true || isAlumniViewPath === true) {
        return;
      } else {
        this.props.actions.removeQuickSearchResult();
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        keys.map((e) => this.remove(e))
        localStorage.removeItem('QuickSearchExp')
        localStorage.removeItem('ContextToken')
        window.location.reload()
      }
    }
  }


  getcolumnlist = (columnname) => {
    let Columnstate = columnname; // this.state.columns;
    let columnArr = Columnstate;
    let columnjsonArr = [];
    const ObjMaper = {
      'firstname': 'FIRST NAME',
      'lastname': 'LAST NAME',
      'home_city': 'CITY',
      'home_state': 'STATE',
      'home_zip5': 'ZIP',
      'eaglecouncilnameandnumber': 'EAGLE COUNCIL',
      'eaglescoutunitnumber': 'EAGLE UNIT NUMBER',
      'eaglescoutunitcity': 'EAGLE UNIT CITY',
      'eaglescoutunitstate': 'EAGLE UNIT STATE',
      'councilaffiliation ': 'COUNCIL AFFILIATION',
      'membershiptype': 'MEMBERSHIP TYPE',
      'membershipstatus': 'MEMBERSHIP STATUS',
    }
    columnArr.map(function (columnname) {
      columnjsonArr.push({
        title: ObjMaper[columnname] || columnname,
        dataIndex: columnname,
        key: columnname,
        sorter: true,
        // sorter: (a, b) => a.columnname - b.columnname,
        defaultSortOrder: '',
        sortDirections: ['descend', 'ascend'],
      })
    })
    if (this.props.isadmin === true && this.props.isSuperAlumniAdmin === true && this.panelView === "adminTabView") {
      columnjsonArr.push({
        dataIndex: "edit",
        key: "edit",
        render: (text, record) => (
          <span className="editRow">
            <Tooltip placement="top" title="Click to Edit">
              <Button onClick={() => this.handleSearchRedirect(record, '/maintain-alumni/')} type="primary" shape="circle" size="small" ><i className="fa fa-pencil"></i></Button>
            </Tooltip>
            {/* <a onClick={() => this.props.history.push('/maintain-alumni/' + record.personguid +'/quick-search')} > <i className="fa fa-pencil margin-right-5"></i> Edit</a> */}
          </span>
        )
      })
    }
    // if(this.props.isadmin || this.props.isspecialist && this.panelView === "adminTabView" || this.panelView === "specialistTabView"){ 
    if(this.props.isSuperAlumniAdmin) {
    columnjsonArr.push({
      dataIndex: "view",
      key: "view",
      render: (text, record) => (
        <span className="viewRow">
          <Tooltip placement="top" title="Click to View">
            <Button onClick={() => this.handleSearchRedirect(record, '/alumni-profile/')} type="primary" shape="circle" size="small" ><i className="fa fa-eye"></i></Button>
          </Tooltip>
        </span>
      )
    })
  } else {
    columnjsonArr.push({
      dataIndex: "view",
      key: "view",
      render: (text, record) => (
        // record.alumniprivacy == 0 ?
              <span className="viewRow">
                <Tooltip placement="top" title="Click to View">
                  <Button onClick={() => this.handleSearchRedirect(record, '/alumni-profile/')} type="primary" shape="circle" size="small" ><i className="fa fa-eye"></i></Button>
                </Tooltip>
                {/* <a onClick={() => this.props.history.push('/alumni-profile/' + record.personguid +'/quick-search')} > <i className="fa fa-eye margin-right-5"></i> View</a> */}
              </span>
              // : null
      )
    })
  }
    columnjsonArr.push({
      dataIndex: "connect",
      key: "connect",
      render: (text, record) => (
        <span>
          {(() => {
            const hasFacebook = record.facebookname && !record.facebookname.includes('*');
            const hasTwitter = record.twittername && !record.twittername.includes('*');
            const hasLinkedin = record.linkedinname && !record.linkedinname.includes('*');
            const hasInstagram = record.instagramname && !record.instagramname.includes('*');

            // if (hasFacebook || hasTwitter || hasLinkedin || hasInstagram) {
              return (<span className="ConnectRow">
                <Popover content={
                  // <div>
                  //   {hasFacebook && <a href={"https://facebook.com/" + hasFacebook } target="_blank"> <i className="fa fa-facebook-square margin-right-5 fa-lg" aria-hidden="true"></i> </a>}
                  //   {/* {hasTwitter != '' && <a href={"https://twitter.com/" + hasTwitter } target="_blank"> <i className="fa fa-twitter-square margin-right-5 fa-lg" aria-hidden="true"></i> </a>} */}
                  //   {hasTwitter && (
                  //     <a
                  //       href={"https://twitter.com/" + record.twittername}
                  //       target="_blank"
                  //       rel="noopener noreferrer"
                  //     >
                  //       <svg
                  //         width="11"
                  //         height="11"
                  //         viewBox="0 0 1200 1227"
                  //         fill="currentColor"
                  //         style={{
                  //           verticalAlign: "middle",
                  //           marginRight: "5px"
                  //         }}
                  //         aria-hidden="true"
                  //       >
                  //         <path d="M714.163 519.284L1160.89 0H1055.36L667.137 451.887L357.328 0H0L468.492 682.21L0 1226.37H105.527L515.256 750.965L841.672 1226.37H1199L714.137 519.284H714.163Z" />
                  //       </svg>
                  //     </a>
                  //   )}
                  //   {hasLinkedin && <a href={"https://linkedin.com/in/" + hasLinkedin } target="_blank"> <i className="fa fa-linkedin-square margin-right-5 fa-lg" aria-hidden="true"></i> </a>}
                  //   {hasInstagram && <a href={"https://instagram.com/" + hasInstagram } target="_blank"> <i className="fa fa-instagram margin-right-5 fa-lg" aria-hidden="true"></i> </a>}
                  // </div>
                  <div>
                    {hasFacebook ? (
                      <a
                        href={"https://facebook.com/" + record.facebookname}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-facebook-square margin-right-5 fa-lg" />
                      </a>
                    ) : (
                      <i
                        className="fa fa-facebook-square margin-right-5 fa-lg social-disabled"
                      />
                    )}

                    {hasTwitter ? (
                      <a
                        href={"https://twitter.com/" + record.twittername}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <svg
                          width="11"
                          height="11"
                          viewBox="0 0 1200 1227"
                          fill="currentColor"
                          style={{
                            verticalAlign: "middle",
                            marginRight: "5px"
                          }}
                        >
                          <path d="M714.163 519.284L1160.89 0H1055.36L667.137 451.887L357.328 0H0L468.492 682.21L0 1226.37H105.527L515.256 750.965L841.672 1226.37H1199L714.137 519.284H714.163Z" />
                        </svg>
                      </a>
                    ) : (
                      <span
                        className="social-disabled"
                        style={{
                          display: "inline-block",
                          marginRight: "5px"
                        }}
                      >
                        <svg
                          width="11"
                          height="11"
                          viewBox="0 0 1200 1227"
                          fill="currentColor"
                        >
                          <path d="M714.163 519.284L1160.89 0H1055.36L667.137 451.887L357.328 0H0L468.492 682.21L0 1226.37H105.527L515.256 750.965L841.672 1226.37H1199L714.137 519.284H714.163Z" />
                        </svg>
                      </span>
                    )}

                    {hasLinkedin ? (
                      <a
                        href={"https://linkedin.com/in/" + record.linkedinname}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-linkedin-square margin-right-5 fa-lg" />
                      </a>
                    ) : (
                      <i
                        className="fa fa-linkedin-square margin-right-5 fa-lg social-disabled"
                      />
                    )}

                    {hasInstagram ? (
                      <a
                        href={"https://instagram.com/" + record.instagramname}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-instagram margin-right-5 fa-lg" />
                      </a>
                    ) : (
                      <i
                        className="fa fa-instagram margin-right-5 fa-lg social-disabled"
                      />
                    )}
                  </div>
                } title="Social Network">
                  <Button type="primary" shape="circle" size="small" ><i className="fa fa-link"></i></Button>
                </Popover>
              </span>)
            // }
          })()}
        </span>
      )
    })
    this.setState({
      columnjson: columnjsonArr,
    });
  }

  onChange = (page, pageSize) => {
    this.setState({
      currentpage: page,
      perPageSize: pageSize,
    });
    let preferenceFilter; //AAG-1283 - The Fix here is - When changing the "per page" count after navigating back to search results (from an alumni profile view), the state values were empty, causing the report to run without filters and return random records.
    if(this.state.preference) {
      preferenceFilter = this.state.preference;
    } else {
      preferenceFilter = this.props.preferenceFilter;
    }
    // this.props.actions.QuickSearch(parseInt(page), parseInt(page), this.state.columns, "quicksearch", pageSize)
        this.props.actions.savelist(preferenceFilter, 'quicksearch', '4', this.state.columns, false, parseInt(pageSize), parseInt(page), this.props.maxRecords )
  }

  showcolumnselection = () => {
    const { form } = this.props;
    const keys = form.getFieldValue("keys");
    if (keys.length == 0) {
      let columnlist = this.state.columns
      columnlist.map((element) => this.add(element))
    }
    this.setState({
      changecolumnvisible: true
    })
  }

  closecolumnselection = () => {
    this.setState({
      changecolumnvisible: false
    })
  }


  handleChange = (records) => {
    let recordsvalue = records.split(",")
    let pages = this.props.alumnirecordsroot.RecordCount / recordsvalue[1];
    // this.setState({
    //   perPageSize: 100,
    //   pagecount: pages,
    // });
    // this.props.actions.QuickSearch(parseInt(this.state.currentpage), parseInt(this.state.currentpage) + parseInt(recordsvalue[0]), this.state.columns, "quicksearch")
    // this.props.actions.QuickSearch(parseInt(this.state.currentpage), parseInt(this.state.currentpage), this.state.columns, "quicksearch", parseInt(this.state.perPageSize))
        this.props.actions.savelist(this.state.preference, 'quicksearch', '4', this.state.columns, false, parseInt(this.state.perPageSize), parseInt(this.state.currentpage), this.props.maxRecords)
  }

  downloadCSV = () => {
    let columns = this.state.columns
    let columnlist = columns.toString()
    this.props.actions.downloadAdvanceSearchResultsAsCSV(columnlist)
  }

  componentWillReceiveProps = (nextProps) => {
    if (!this.props.preferencelist && (nextProps.preferencelist && nextProps.preferencelist.length > 0)) {
      nextProps.preferencelist.forEach(item => {
        if (item.ethnicityid) {
          const ethnicity = this.props.ethnicities.find(eth => eth.id === item.ethnicityid);
          if (ethnicity) {
            item.ethnicity = ethnicity.name;  // Modify the item directly
          }
        }
      });
    }
    if (this.props.alumnirecordsroot && this.state.pagecount == 0) {
      this.setState({
        pagecount: this.props.alumnirecordsroot.PageCount,
      })
    }
  }

  filterColumn = (columnname) => {
    this.getcolumnlist(columnname)
    this.setState({
      columns: columnname
    })
  }

  preference = (value) => {
    console.log("**** getPreference **** ", JSON.stringify(value));
    this.setState({
      preference: value
    })
  }

  Removefilter = () => {
    let columnjson = this.state.columnjson
    columnjson.map((k, index) => {
      //columnjson[index].sortDirections = ["ascend", "descend"]
    })
    this.setState({
      columnjson: columnjson
    })
  }

  handleTableChange = (pagination, filters, sorter) => {
    let soter_values = sorter
    let columnjson = this.state.columnjson
    columnjson.map((k, index) => {
      if (k.key == soter_values.columnKey) {
        let defaultSortOrder = (soter_values.order == "descend") ? "descend" : "ascend"
        columnjson[index].sortDirections = ['descend', 'ascend']
        if (columnjson[index].defaultSortOrder == "") {
          columnjson[index].defaultSortOrder = "ascend"
          sorter.order = "ascend"
        }
        else if (columnjson[index].defaultSortOrder == "ascend") {
          columnjson[index].defaultSortOrder = "descend"
          sorter.order = "descend"
        }
        else if (columnjson[index].defaultSortOrder == "descend") {
          columnjson[index].defaultSortOrder = "ascend"
          sorter.order = "ascend"
        }
      }
      else {
        columnjson[index].sortDirections = ['descend', 'ascend']
      }
    })
    this.setState({
      columnjson: columnjson
    })

    this.props.actions.SortTable(sorter)
  };

  onShowSizeChange = (current, pageSize) => {
    console.log(current, pageSize);
    // this.props.actions.QuickSearch(parseInt(current), parseInt(current), this.state.columns, "quicksearch", pageSize)
    let preferenceFilter; //AAG-1283 - The Fix here is - When changing the "per page" count after navigating back to search results (from an alumni profile view), the state values were empty, causing the report to run without filters and return random records.
    if(this.state.preference) {
      preferenceFilter = this.state.preference;
    }     else {
      preferenceFilter = this.props.preferenceFilter;
    }
    
    this.props.actions.savelist(preferenceFilter, 'quicksearch', '4', this.state.columns, false, parseInt(pageSize), parseInt(current) , this.props.maxRecords)
    this.setState({
      currentpage: current,
      perPageSize : pageSize
    })
  }

  renderQuickSearch = () => {
    if (this.props.preferencedata) {
      let preferencedataArray = this.props.preferencedata.Filters.Expressions
      // preferencedataArray.map((k, index) => {
      //   preferencedataArray[k]
      // })
    }
    if (this.props.preferencelist) {
      let getTotalRecordCount;
       if(this.props.TotalRecordCount) getTotalRecordCount = this.props.TotalRecordCount;
       else if(this.props.alumnirecordsroot && this.props.alumnirecordsroot.RecordCount) getTotalRecordCount = this.props.alumnirecordsroot.RecordCount
       else getTotalRecordCount = 0;

       const targetId = sessionStorage.getItem('scrollToId');
       if (targetId) {

        setTimeout(() => {
          const el = document.getElementById(targetId);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
          sessionStorage.removeItem('scrollToId'); // clean up

        }, 200);

        
       }

      return (
        <div >
          <div className= "tab-container" style={{display: 'flex', alignItems: 'center'}}>
            <Row  style={{display: 'flex', alignItems: 'center', width: '100%'}}>
              <Col span={6}>
                {
                  this.props.isadmin == true &&
                  <div className="content-filter" style={{ background: "transparent", fontSize: '15px', padding: "10px 0px", fontWeight: 'normal', justifyContent: 'flex-start' }}>
                    <label className="downloadBtn pointer" >
                      <Button type='default'style={{ color: "#515354", background: "transparent", border: 'none' }}
                        onClick={() => {
                          this.downloadCSV()
                        }}
                      >
                          Download CSV
                        <i className="fa fa-cloud-download margin-left-5" style={{ fontSize: '20px' }}></i>
                      </Button>
                    </label>
                    <ReactToPrint
                      trigger={() => <label class="downloadBtn pointer" style={{color: '#515354'}}>Print
                      <i className="fa fa-print margin-left-5"></i> 
                      </label>}
                      content={() => this.componentRef}
                    />
                  </div>
                }
              </Col>

              <Col span={18} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', paddingRight: '20px' }}>
                <span className="records-count">Total Contacts: <b>{getTotalRecordCount}</b></span>
                <Pagination
                  style={{ marginLeft: '10px' }}
                  defaultCurrent={this.state.currentpage}
                  // pageSize={this.state.perPageSize}
                  defaultPageSize={this.state.perPageSize}
                  pageSizeOptions={['10', '20', '30', '40', '100']}
                  showSizeChanger
                  onShowSizeChange={this.onShowSizeChange}
                  total={getTotalRecordCount}
                  showTotal={(total, range) => `${range[0]}-${range[1]} of ${getTotalRecordCount} search results`}
                  size='small'
                  onChange={this.onChange}
                />
              </Col>
              
              

              {/* <Col span={6}>
                <Input name="txt_search" onChange={this.SearchPending} className="searchInput" size="small" prefix={< Icon type="search" />} placeholder="Search by Name" />
              </Col> */}
            </Row>
          </div>
          
          {/* {this.props.isadmin == true &&
            <div className="content-filter">
              <label className="downloadBtn pointer" onClick={this.downloadCSV}>
                <i className="fa fa-file-excel-o margin-right-5"></i> Download
              </label>

              <ReactToPrint
                trigger={() => <label class="printLabel"><i className="fa fa-print margin-right-5"></i> Print</label>}
                content={() => this.componentRef}
              />

          
            </div>
          } */}

          <Table
            className="quick-search-table"
            ref={el => (this.componentRef = el)}
            dataSource={this.props.preferencelist || this.props.alumnirecords}
            columns={this.state.columnjson}
            pagination={false}
            onChange={this.handleTableChange}
          />
{/* 
          <div className="content-filter-bottom">
            <span className="records-count">Total Contacts: <b>{this.props.alumnirecordsroot ? this.props.alumnirecordsroot.RecordCount : 0}</b></span>
            <Pagination current={this.state.currentpage} pageSize="100"    onChange={this.onChange} total={this.props.alumnirecordsroot ? this.props.alumnirecordsroot.RecordCount : 0} />
            
          </div> */}

          <div className="tab-container" style={{ display: 'flex', alignItems: 'center', borderRadius: '0px' , backgroundColor: '#f2f2f2' }}>
            <Row style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <Col span={24} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', paddingRight: '20px' }}>
                <span className="records-count">Total Contacts: <b>{getTotalRecordCount}</b></span>
                <Pagination
                  style={{ marginLeft: '10px' }}
                  defaultCurrent={this.state.currentpage}
                  // pageSize={this.state.perPageSize}
                  defaultPageSize={this.state.perPageSize}
                  pageSizeOptions={['10', '20', '30', '40', '100']}
                  showSizeChanger
                  onShowSizeChange={this.onShowSizeChange}
                  total={getTotalRecordCount}
                  showTotal={(total, range) => `${range[0]}-${range[1]} of ${getTotalRecordCount} search results`}
                  size='small'
                  onChange={this.onChange}
                />
              </Col>
            </Row>
          </div>
        </div>
      )
    }

    // if (this.props.recordsLoading) {
    //   return (
    //       <div>
    //           <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Contacts..." />
    //       </div>
    //   );
    // }
    
    if (window.location.pathname.includes('/quick-search') && this.props.quickRecordsLoading) {
        return (
            <div>
                <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Contacts..." />
            </div>
        );
      }

    if (window.location.pathname.includes('/alumni-search') && this.props.alumniRecordsLoading) {
        return (
            <div>
                <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Contacts..." />
            </div>
        );
    }

    if (this.props.alumnirecordsroot) {
      if (this.props.alumnirecordsroot.RecordCount === 0) {
          return (
              <div>
                  <p className="suspend-msg">No Records Found!</p>
              </div>
          );
      }
    }

    if (!this.props.preferencedata) {
      return <Row className='empty-container' type="flex" justify="space-between" align="middle">
        <Col span={24}>
          <span> You have not selected any filters! </span>
          <small> Please select any filters to view results.</small>
        </Col>
      </Row>
    }

    this.forceUpdate()
  }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    getFieldDecorator("keys", { initialValue: [] });
    const keys = getFieldValue("keys");
    getFieldDecorator("selectedvalueArray", { initialValue: [] });
    const selectedcolumnvalue = this.state.selectedcolumnvalue
    const formItems = keys.map((k, index) => {
      return (
        <Draggable key={k} draggableId={++k} index={k}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              style={getItemStyle(
                snapshot.isDragging,
                provided.draggableProps.style
              )}
            >
              <Row type="flex" justify="center" align="middle">
                <Col span={1}>
                  <i {...provided.dragHandleProps} className="drag-handler pointer fa fa-lg fa-ellipsis-v"></i>
                </Col>
                <Col span={18}>
                  <FormItem
                    required={false}
                    key={k}
                  >
                    {getFieldDecorator(`columns[${k}]`, {
                      initialValue: this.state.columns[k - 1],
                      validateTrigger: ["onChange", "onBlur"],
                      rules: [
                        {
                          required: true,
                          whitespace: true,
                        }
                      ]
                    })(
                      <Select

                      >
                        <Option value="firstname">First Name</Option>
                        <Option value="lastname">Last Name</Option>
                        <Option value="home_city">City</Option>
                        <Option value="home_state">State</Option>
                        <Option value="home_zip5">Zip/Postal Code</Option>
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={2}>
                  <FormItem>
                    <Icon className="cancel-icon pointer" onClick={() => this.remove(k)} type="close" />
                  </FormItem>
                </Col>
              </Row>
            </div>
          )}
        </Draggable>
      );
    });
    return (
      <div>

        {this.props.location.pathname == '/alumni-search' ? <SimplSearch Removefilter={this.Removefilter} preference={this.preference} filterColumn={this.filterColumn} perPageSize={ parseInt(this.state.perPageSize)} /> : <SearchAlumniFilter Removefilter={this.Removefilter} preference={this.preference} filterColumn={this.filterColumn} perPageSize={ parseInt(this.state.perPageSize)} currentpageHandler={() => this.setState({ currentpage: 1 })} />}

        <div className="widget">
          <div className="container-sub-title">
        <div className="sub-title">
                Constituent Results
              </div>
        </div>
        </div>

        <div className="widget">
          <div className="widget-container quick-search">
            {/* <div className="widget-header">
              <div className="title">
                Constituent Results
              </div>
            </div> */}

            {this.renderQuickSearch()}

          </div>
        </div>
        
         <div id='alumni-search-results'></div> {/* scroll down the "Alumni seach" page automatically when comes back from the alumni's profile page */}

        <Modal
          title="Change Columns"
          centered
          className="column-list-selection"
          visible={this.state.changecolumnvisible}
          footer={[

          ]}
        >
          <Form onSubmit={this.handleSubmit}>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle()}
                  >

                    {formItems}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>



            <Row type="flex" justify="flex-end" align="middle">
              <Col span={21}>
                <div className="add-column-panel">
                  <span className="pointer" onClick={() => this.add([''])}><Icon type="plus-circle-o" /> Add Column</span>
                </div>
              </Col>
            </Row>

            <Row type="flex" justify="space-around">
              <Col xs={24} sm={24} md={8} lg={8}>
                <Button className="cancelbtn" onClick={() => this.closecolumnselection(false)}> Cancel </Button>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8}>
                <FormItem>
                  <Button className="submitbtn" htmlType="submit"> Submit </Button>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    alumnirecordsroot: state.quicksearchrootreducer.alumnirecordsroot,
    alumnirecords: state.quicksearchreducer.alumnirecords,
    isFetching: state.quicksearchreducer.isFetching,
    preferencelist: state.runpreferencelistreducer.preferencelist,
    preferenceFilter: state.runpreferencelistreducer.preferenceFilter,
    preferencedataloading: state.getpreferencedatareducer.loading,
    runPreferenceLoading: state.runpreferencelistreducer.loading,
    preferencedata: state.getpreferencedatareducer.preferencedata,
    maxRecords: state.runpreferencelistreducer.maxRecords,
    TotalRecordCount: state.runpreferencelistreducer.TotalRecordCount,
    isadmin: state.isadminreducer.isadmin,
    isspecialist: state.isadminreducer.isspecialist,
    ethnicities_loading: state.ethnicitiesreducer.loading,
    ethnicities: state.ethnicitiesreducer.ethnicities,
    isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
    quickRecordsLoading: state.quickRecordsLoaderReducer.loading,
    alumniRecordsLoading: state.alumniRecordsLoaderReducer.loading
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

const SearchAlumni = Form.create()(SearchAlumniClass);


export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(SearchAlumni);


// WEBPACK FOOTER //
// ./src/components/Inc/SearchAlumni.js